module.exports = __webpack_public_path__ + "img/TRUCK.c7e7f1a0.svg";